// import addRecharge from '../components/weighing/addRecharge.vue'
// import rechargeList from '../components/weighing/rechargeList.vue'
// import weighingList from '../components/weighing/weighingList.vue'
// import weightRecord from '../components/weighing/weightRecord.vue'
// import addCard from '../components/weighing/addCard.vue'
// import cardManage from '../components/weighing/cardManage.vue'
// import viewCzRecord from '../components/weighing/viewCzRecord.vue'
// import viewJyRecord from '../components/weighing/viewJyRecord.vue'

export default [
    { 
        path: 'weighing/addRecharge', 
        component: resolve => require(['@/components/weighing/addRecharge'],resolve),
        name:'AddRecharge',
        meta:{
            id:'979',
            node:'weighing',
            url:'addRecharge',
        }
    },
    { 
        path: 'weighing/rechargeList', 
        component: resolve => require(['@/components/weighing/rechargeList'],resolve),
        name:'RechargeList',
        meta:{
            id:'978',
            node:'weighing',
            url:'rechargeList',
        }
    },
    { 
        path: 'weighing/weighingList', 
        component: resolve => require(['@/components/weighing/weighingList'],resolve),
        name:'WeighingList',
        meta:{
            id:'976',
            node:'weighing',
            url:'weighingList',
        }
    },
    { 
        path: 'weighing/weightRecord', 
        component: resolve => require(['@/components/weighing/weightRecord'],resolve),
        name:'WeightRecord',
        meta:{
            id:'981',
            node:'weighing',
            url:'weightRecord',
        }
    },
    { 
        path: 'weighing/addCard', 
        component: resolve => require(['@/components/weighing/addCard'],resolve),
        name:'AddCard',
        meta:{
            id:'984',
            node:'weighing',
            url:'addCard',
        }
    },
    { 
        path: 'weighing/cardManage', 
        component: resolve => require(['@/components/weighing/cardManage'],resolve),
        name:'CardManage',
        meta:{
            id:'983',
            node:'weighing',
            url:'cardManage',
        }
    },
    { 
        path: 'weighing/viewCzRecord', 
        component: resolve => require(['@/components/weighing/viewCzRecord'],resolve),
        name:'ViewCzRecord',
        meta:{
            // id:'350',
            node:'weighing',
            url:'viewCzRecord',
        }
    },
    { 
        path: 'weighing/viewJyRecord', 
        component: resolve => require(['@/components/weighing/viewJyRecord'],resolve),
        name:'ViewJyRecord',
        meta:{
            // id:'350',
            node:'weighing',
            url:'viewJyRecord',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/weighing.js